import { FhirService } from 'src/app/core/service/fhir.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../authentication/authentication.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AppConfigService } from './app-config.service';
import { tap } from 'rxjs/operators';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable()
export class JwtInterceptorService implements HttpInterceptor
{
    constructor(
        public authService: AuthenticationService,
        private router: Router,
        private fhirService: FhirService,
        private sessionStorageService: SessionStorageService,
        private appConfigService: AppConfigService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const config = this.appConfigService.getConfig();
        const baseApiUrl = config.api.baseUrl;
        const currentUser = this.authService.currentUser;
        const isAbsoluteURLRegex = /^(?:\w+:)\/\//;
        const isFHIRAuth = request.url === '/authenticate' && this.fhirService.issuer !== null;
        const isTotpVerification = request.url.indexOf('/authenticate/code/verify') >= 0 ||
            request.url.indexOf('/authenticate/code/send') >= 0;
        const isLogout = request.url === '/logout';

        // If authenticated, set Authorization header. Must not inject bearer token if url contains /csp/
        if ((currentUser && request.url.indexOf('/csp/') === -1) || isTotpVerification || isLogout)
        {
            const token = isTotpVerification ? this.authService.totpToken :
                isLogout ? this.sessionStorageService.retrieve('logout_token') : currentUser.token;

            if (isLogout) { this.sessionStorageService.clear('logout_token'); }

            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        // If not absolute URL (REST API), add base url automatically
        let urlPrefix = '';
        if (!isAbsoluteURLRegex.test(request.url) && request.url.substring(0, 1) === '/')
        {
            urlPrefix = baseApiUrl;
        }

        // Clone request to set url
        const apiRequest = request.clone({ url: `${urlPrefix}${request.url}` });

        return next.handle(apiRequest).pipe(
            tap({
                error: (err: any) =>
                {
                    if (err instanceof HttpErrorResponse)
                    {
                        switch (err.status)
                        {
                            case 401:
                                // If FHIR Authentication is not successfull, do not redirect to login 
                                // We do not redirect flowable to login because in twofa context, user unable to enter their code (accounts might be out of synch).
                                if (!isFHIRAuth && !request.url.includes('flowable-idm/app/authentication'))
                                {
                                    this.router.navigate(['login']);
                                }
                                break;
                            case 404:
                                this.router.navigate(['not-found']);
                                break;
                        }
                        return;
                    }
                }
            }));
    }
}
